import React from 'react';
import ContentSubmissionsTab from '@/views/campaigns/content-submissions/ContentSubmissionsTab';
import Page from '@/components/page';
import layoutStyles from '../OffPlatformLayout.module.scss';

function OffPlatformContentSubmissions() {
  return (
    <Page
      className={layoutStyles.contentSubmissions}
      childrenClassName={layoutStyles.contentSubmissionsChildren}
    >
      <ContentSubmissionsTab isOffPlatform />
    </Page>
  );
}

export default OffPlatformContentSubmissions;
